export const Features = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F6F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="m7.809 13.315 4.585 4.585 7.8-7.8"
    ></path>
  </svg>
)

export const MessagesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F6F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.25"
      d="M19.225 15.828a.62.62 0 0 1 .111-.411 1 1 0 0 1 .071-.1c.605-.9.93-1.959.93-3.043a5.73 5.73 0 0 0-5.849-5.631A5.81 5.81 0 0 0 8.75 11.12a5.4 5.4 0 0 0-.125 1.152 5.716 5.716 0 0 0 5.762 5.7 7 7 0 0 0 1.59-.26c.381-.1.758-.242.856-.28a.9.9 0 0 1 .653.01l1.91.678q.063.027.131.034a.27.27 0 0 0 .27-.27.4.4 0 0 0-.017-.091z"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="1.25"
      d="M6.964 12.826a4.93 4.93 0 0 0 .215 5.144c.078.118.122.21.108.27s-.4 2.085-.4 2.085a.27.27 0 0 0 .09.26.28.28 0 0 0 .275.04l1.894-.742a.53.53 0 0 1 .4.007 5.7 5.7 0 0 0 2.05.4 5.37 5.37 0 0 0 2.7-.724"
    ></path>
  </svg>
)

export const CalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F6F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      fill="#F6F7F7"
      stroke="#2773C1"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M19.856 7.36H8a1 1 0 0 0-1 1v10.856a1 1 0 0 0 1 1h11.856a1 1 0 0 0 1-1V8.36a1 1 0 0 0-1-1Z"
    ></path>
    <path
      fill="#F6F7F7"
      d="M9.87 6.216v.914zm9.182 0v.914zm1.8 3.198H7z"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M9.87 6.216v.914m9.182-.914v.914m1.8 2.284H7"
    ></path>
  </svg>
)

export const ChartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F7F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M7 7v13.5a.5.5 0 0 0 .5.5H21"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M11 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zM15.986 12.5a1.5 1.5 0 1 0-3 0v5a1.5 1.5 0 0 0 3 0zM20.488 10.756a1.252 1.252 0 0 0-2.504 0v6.988a1.252 1.252 0 1 0 2.504 0z"
    ></path>
  </svg>
)

export const VideocamIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F7F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m17.802 15.655 2.514 1.826a.47.47 0 0 0 .463-.038.5.5 0 0 0 .22-.421v-6.047a.5.5 0 0 0-.22-.421.47.47 0 0 0-.463-.038l-2.514 1.826a.5.5 0 0 0-.206.41v2.49a.5.5 0 0 0 .206.41z"
    ></path>
    <path
      stroke="#2773C1"
      strokeMiterlimit="10"
      strokeWidth="1.25"
      d="M14.174 18H8.581a1.61 1.61 0 0 1-1.58-1.625v-4.75A1.61 1.61 0 0 1 8.58 10h5.608a1.593 1.593 0 0 1 1.566 1.61v4.765A1.61 1.61 0 0 1 14.175 18Z"
    ></path>
  </svg>
)

export const DocumentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
  >
    <path
      fill="#F7F7F7"
      d="M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M16.537 14.225v5.394A1.36 1.36 0 0 1 15.19 21H9.35A1.36 1.36 0 0 1 8 19.62v-8.286a1.39 1.39 0 0 1 1.381-1.38h2.954a.77.77 0 0 1 .55.23l3.425 3.484a.8.8 0 0 1 .227.557Z"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M12.24 9.994v3.39a.89.89 0 0 0 .88.88h3.39"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M11.463 10.013V8.381A1.39 1.39 0 0 1 12.843 7h2.95a.78.78 0 0 1 .554.231l3.426 3.484a.79.79 0 0 1 .227.554v5.4a1.36 1.36 0 0 1-1.348 1.381h-1.916"
    ></path>
    <path
      stroke="#2773C1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M15.732 7v3.39a.89.89 0 0 0 .88.879h3.39"
    ></path>
  </svg>
)
